import { MaterialIndexRouteView } from './view';

export const indexRoute = {
  index: true,
  element: <MaterialIndexRouteView/>,
};